export const isSp = (): boolean => {
  if (typeof window !== "object") {
    return false;
  }
  const ua = window.navigator.userAgent;
  return (
    ua.indexOf("iPhone") > 0 ||
    ua.indexOf("iPod") > 0 ||
    (ua.indexOf("Android") > 0 && ua.indexOf("Mobile") > 0)
  );
};